import React, { useEffect, useState } from 'react';
import {Button} from 'react-bootstrap';

import { useTranslate } from 'react-polyglot';
import 'react-toastify/dist/ReactToastify.css';
import './BookingGuests.scss';
import FilterSelector from '../../../Shared/FilterSelector/FilterSelector';
import PageTable from '../../../Shared/PageTable/PageTable';
import CreatePersonModal from '../../../Shared/Modals/Create/CreatePersonModal';
import EditPersonModal from '../../../Shared/Modals/Edit/EditPersonModal';
import DeletePersonModal from '../../../Shared/Modals/Delete/DeletePersonModal';
import CreateMultiplePersonsModal from '../../../Shared/Modals/Create/CreateMultiplePersonsModal';
import SMSSender from '../../../Shared/SMSSender/SMSSender';
import EmailSender from '../../../Shared/EmailSender/EmailSender';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../Auth';

import moment from 'moment';

function BookingGuests(props) {
    const auth = useAuth();
    const t = useTranslate();
    const [updateTable, setUpdateTable] = useState(0);

    const [personsFilter, setPersonsFilter] = useState([]);

    const [showCreateMultiplePersonsModal, setShowCreateMultiplePersonsModal] = useState(false);
    const [showCreatePersonModal, setShowCreatePersonModal] = useState(false);
    const [showDeletePersonModal, setShowDeletePersonModal] = useState(false);
    const [showEditPersonModal, setShowEditPersonModal] = useState(false);
    const [showSMSSendModal, setShowSMSSendModal,] = useState(false);
    const [showEmailSendModal, setShowEmailSendModal,] = useState(false);

    const [editPersonId, setEditPersonId] = useState();
    const [editPersonOrg, setEditPersonOrg] = useState("");
    const [deletePersonId, setDeletePersonId] = useState();

    const [hasGuests, setHasGuests] = useState(false);
    const [selectedItems, setSelectedItems] = useState<any>([]);
    const [action, setAction] = useState("");

    const handleShowCreateModal = () => { setShowCreatePersonModal(true); };
    const handleShowSMSSendModal = () => { setShowSMSSendModal(true); };
    const handleShowEmailSendModal = () => { setShowEmailSendModal(true); };

    let customer = props.customers.find(customer => customer._id == props.booking.customerId);

    const localStorageUser = localStorage.getItem("user");
    let settings;
    if (localStorageUser != null) {
        settings = JSON.parse(localStorageUser)["settings"];
    }

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const handleGuestDeleted = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        let tempBooking = props.booking;
        
        tempBooking["guests"] = tempBooking.guests.filter( item => {
            return item._id != dataLine._id;
        })
        
        if (props.onChange != undefined) {
            props.onChange(JSON.parse(JSON.stringify(tempBooking)));
        }

        if (props.onGuestDelete != undefined) {
            props.onGuestDelete();
        }
        
        setUpdateTable(updateTable + 1);
    };
    
    const handleShowEditModal = (dataLine) => {
        setEditPersonId(dataLine["_id"]);
        setEditPersonOrg(dataLine["organization"]);
        setShowEditPersonModal(true);
        setUpdateTable(updateTable + 1);
    };

    const handleMultipleGuestsAdded = (guests) =>{
        setShowCreateMultiplePersonsModal(false);
        
        let tempBooking = props.booking;

        if (tempBooking.guests == undefined) tempBooking.guests = [];

        guests.forEach(guest => {
            // only push if doesnt exist
            if (!tempBooking.guests.map(g => g._id).includes(guest._id)) {
                tempBooking.guests.push({_id: guest._id });
            }
        });

        if (props.onChange != undefined) {
            props.onChange(JSON.parse(JSON.stringify(tempBooking)));
        }
        if (props.onGuestAdd != undefined) {
            props.onGuestAdd();
        }
        
        setUpdateTable(updateTable + 1);
    }

    const handleGuestAdded = (guest) =>{
        setShowCreatePersonModal(false);

        let tempBooking = props.booking;

        if (tempBooking.guests == undefined) tempBooking.guests = [];

        // only push if doesnt exist
        if (!tempBooking.guests.map(g => g._id).includes(guest._id)) {
            tempBooking.guests.push({_id: guest._id });
     }

        if (props.onChange != undefined) {
            props.onChange(JSON.parse(JSON.stringify(tempBooking)));
        }
        if (props.onGuestAdd != undefined) {
            props.onGuestAdd();
        }

        setUpdateTable(updateTable + 1);
    }

    const handleSendSMS = (selectedItems) => {
        setSelectedItems(selectedItems);
        setAction("SMS");
        handleShowSMSSendModal();
    }

    const handleSendEmail = (selectedItems) => {
        setSelectedItems(selectedItems);
        setAction("Email");
        handleShowEmailSendModal();
    }

    const handleSendConfirmationSMS = (selectedItems) => {
        setSelectedItems(selectedItems);
        setAction("confirmation");
        handleShowSMSSendModal();
    }

    const handleSendConfirmationEmail = (selectedItems) => {
        setSelectedItems(selectedItems);
        setAction("confirmation");
        handleShowEmailSendModal();
    }

    function dateToText(date) {
        return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    }

    function generateConfirmationMessageSms(person) {
        let message = "";
        
        let resources = props.allResources.filter(r => r.bookings.some(b => b.bookingId == props.booking._id));

        let bookings = Array.prototype.concat.apply([], resources.map(r => { 
            return r.bookings.filter(b => b.bookingId == props.booking._id).map(b => {
                return {
                    ...b,
                    resource: r
                }
            });
        }));

        let personBookings = bookings.filter(b => b.people.some(p => p == person._id));

        let SmsMessage = settings?.confirmationTextSms ?? "";

        if (SmsMessage == undefined || SmsMessage == "") {
            message += t("booking.guests.confirmationmessage.line1") + "\n\n";
            message += t("booking.guests.confirmationmessage.line2") + "\n";
        } else {
            message = SmsMessage;
        }

        let bookingsMessage = "";
        for (const personBooking of personBookings) {

            let isSpecified = false;
            for (let personBookingtime of personBooking.bookingtimes) {
                if (personBookingtime.people != undefined && personBookingtime.people.includes(person._id)) {
                    isSpecified = true;
                }
            }

            let personBookingtimes = personBooking.bookingtimes.filter(bt => bt != undefined && (moment(bt.start) > moment().add(-1, "day")));
            
            if (isSpecified) {
                personBookingtimes = personBookingtimes.filter(bt => bt.people?.includes(person._id) ?? false);
            }

            if (personBookingtimes.length > 0) {
                bookingsMessage += personBooking.resource.name + "\n";
            }

            for (const bookingtime of personBookingtimes) {
                bookingsMessage += dateToText(new Date(bookingtime.start)) + " " + t("booking.guests.confirmationmessage.to") + " " + dateToText(new Date(bookingtime.end)) + "\n";
            }

            if (personBookingtimes.length > 0) {
                bookingsMessage += "\n";
            }
        }
        
        if (SmsMessage == undefined || SmsMessage == "") {
            message += bookingsMessage;
        } else {
            message = message.replaceAll("[bookings]", bookingsMessage.slice(0, -2));
            message = message.replaceAll("[guest-firstname]", person.firstname);
            message = message.replaceAll("[guest-lastname]", person.lastname);
            message = message.replaceAll("[guest-organisation]", person.organization);
        }
        
        if (SmsMessage == undefined || SmsMessage == "") {
            message += t("booking.guests.confirmationmessage.line3") + "\n";
            message += t("booking.guests.confirmationmessage.line4");
        }

        return message;
    }

    function generateConfirmationMessageEmail(person) {
        let message = "";

        let resources = props.allResources.filter(r => r.bookings.some(b => b.bookingId == props.booking._id));
        let bookings = Array.prototype.concat.apply([], resources.map(r => { 
            return r.bookings.filter(b => b.bookingId == props.booking._id).map(b => {
                return {
                    ...b,
                    resource: r
                }
            });
        }));
        let personBookings = bookings.filter(b => b.people.some(p => p == person._id));let bookingsMessage = "";
        for (const personBooking of personBookings) {
            
            let isSpecified = false;
            for (let personBookingtime of personBooking.bookingtimes) {
                if (personBookingtime.people != undefined && personBookingtime.people.includes(person._id)) {
                    isSpecified = true;
                }
            }

            let personBookingtimes = personBooking.bookingtimes.filter(bt => bt != undefined && (moment(bt.start) > moment().add(-1, "day")));
            
            if (isSpecified) {
                personBookingtimes = personBookingtimes.filter(bt => bt.people?.includes(person._id) ?? false);
            }

            if (personBookingtimes.length > 0) {
                bookingsMessage += personBooking.resource.name + "\n";
            }

            for (const bookingtime of personBookingtimes) {
                bookingsMessage += dateToText(new Date(bookingtime.start)) + " " + t("booking.guests.confirmationmessage.to") + " " + dateToText(new Date(bookingtime.end)) + "\n";
            }

            if (personBookingtimes.length > 0) {
                bookingsMessage += "\n";
            }
        }

        let emailMessage = settings?.confirmationTextEmail ?? "";

        if (emailMessage == undefined || emailMessage == "") {
            message += t("booking.guests.confirmationmessageemail.all");
        } else {
            message = emailMessage;

            message = message.replaceAll("[bookings]", bookingsMessage.slice(0, -2));
            message = message.replaceAll("[guest-firstname]", person.firstname);
            message = message.replaceAll("[guest-lastname]", person.lastname);
            message = message.replaceAll("[guest-organisation]", person.organization);
        }

        return message;
    }

    function customerToGuest(){
        if (customer == undefined){
            notifyWarning(t("booking.guests.toast_customerNotDefined"));
        } else {
            if( 
                customer.lastname == "" || customer.lastname == undefined || 
                customer.firstname == "" || customer.firstname == undefined ||
                customer.phone == "" || customer.phone == undefined ||
                customer.email == "" || customer.email == undefined ){
                notifyWarning(t("booking.guests.toast_customerLackData"))
                return undefined;
            }
            //Add customer contact person as person if not exist and add person id to guest list on booking.
            
            let personExists = props.people.find(person => person.phone == customer.phone);
            if (props.booking.guests == undefined) props.booking.guests = [];
            if (personExists != undefined){

                let tempBooking = props.booking;
                //if (tempBooking.guests == undefined) tempBooking.guests = [];

                tempBooking.guests.push({_id: personExists._id });
                if (props.onChange != undefined) {
                    props.onChange(JSON.parse(JSON.stringify(tempBooking)));
                }
                if (props.onGuestAdd != undefined) {
                    props.onGuestAdd();
                }
                setUpdateTable(updateTable + 1);
            } else {
                props.onCustomerToPerson(customer);
            }            
        }
    }

    useEffect(() => {
        if (props.booking.guests != undefined) {
            setUpdateTable(updateTable + 1);
            if (!hasGuests) {
                setUpdateTable(updateTable + 1);
                setHasGuests(true);
            }
        }
    }, [props.booking.guests]);

   
    return (
        <div style={{ marginTop: '30px'}}>
            <h4 className="header-title">{t("booking.guests.title")}</h4>
            <div>
                <Button className="newpersonBtn" onClick={handleShowCreateModal}>{t("booking.guests.add")}</Button>
                <br/>
                <br/>
                <Button className="newpersonBtn" onClick={() => setShowCreateMultiplePersonsModal(true)}>{t("booking.guests.addmulti")}</Button>
                <br />
                <br />
                <Button className="newpersonBtn" onClick={customerToGuest}>{t("booking.guests.addCustomerAsGuest")}</Button>
            </div>
            <br/>
            <div>
                <p>{t("booking.billing.guests.filters")}</p>
                <FilterSelector
                    filtersUrl="/api/filters/bytype/"
                    filterType="person"
                    fields={[
                        { label: t("booking.billing.guests.lastname"), value: "lastname", type: "string"},
                        { label: t("booking.billing.guests.firstname"), value: "firstname", type: "string"},
                        { label: t("booking.billing.guests.email"), value: "email", type: "string"},
                        { label: t("booking.billing.guests.phone"), value: "phone", type: "string"},
                    ]}
                    onChange={(filter) => {
                        setPersonsFilter(filter.filters);
                    }}
                    onAddClick={() => {

                    }}
                    onEditClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                    onDeleteClick={() => {

                    }}
                    addFilterText={t("people.addfilter")}
                ></FilterSelector>
            </div>
            <PageTable
                dataUrl="/api/persons/getAllPaged/byList"
                checkAllUrl={props.booking != undefined && props.booking._id != undefined ? "/api/persons/getAllPaged/checkAll/bybooking/" + props.booking._id : undefined }
                allDataUrl= {props.booking != undefined && props.booking._id != undefined ? "/api/persons/bybooking/" + props.booking._id : undefined}
                selectedFunctions={[
                    { label: "Send SMS", func: (selectedItems) => { handleSendSMS(selectedItems); } },
                    { label: "Send SMS Confirmation", func: (selectedItems) => {handleSendConfirmationSMS(selectedItems); } },
                    { label: "Send Email", func: (selectedItems) => {handleSendEmail(selectedItems); } },
                    { label: "Send Email Confirmation", func: (selectedItems) => {handleSendConfirmationEmail(selectedItems); } },
                ]}
                data={{
                    list: props.booking.guests != undefined && props.booking.guests.length > 0 ? props.booking.guests.map(person => person._id) : []
                }}
                options={{
                    showFields: [
                        { label: t("people.lastname"), field: "lastname"},
                        { label: t("people.firstname"), field: "firstname"},
                        { label: t("people.email"), field: "email"},
                        { label: t("people.phone"), field: "phone"},
                    ]
                }}
                dataAfter={(dataLine) => <Button onClick ={(evt) => handleGuestDeleted(dataLine, evt)}> {t("people.delete")} </Button>}
                onLineClick= {handleShowEditModal}
                hidePagination= {false}
                hidePagesize= {false}
                hideFilter= {false}
                updateTable={updateTable}
                hover={true}
                permaFilters={personsFilter}
            />
            <CreateMultiplePersonsModal
                show={showCreateMultiplePersonsModal}
                booking={props.booking}
                onCancel={() => setShowCreateMultiplePersonsModal(false)}
                onHide={() => setShowCreateMultiplePersonsModal(false)}
                onSaveNew={(createdPeople) => handleMultipleGuestsAdded(createdPeople)}
            ></CreateMultiplePersonsModal>
            <CreatePersonModal
                show={showCreatePersonModal}
                booking={props.booking}
                customer={customer}
                people={props.people}
                onCancel={() => setShowCreatePersonModal(false)}
                onHide={() => setShowCreatePersonModal(false)}
                onSelectExisting={(selectedPerson) => handleGuestAdded(selectedPerson)}
                onSaveNew={(createdPerson) => handleGuestAdded(createdPerson)}
            ></CreatePersonModal>
            <EditPersonModal
                show={ showEditPersonModal }
                personId= { editPersonId }
                org={editPersonOrg}
                onCancel={() => setShowEditPersonModal(false)}
                onHide={() => {
                    setShowEditPersonModal(false);
                    //setEditPersonId(undefined);
                }}
                onSaveEdit={() => { 
                    setShowEditPersonModal(false); 
                    setUpdateTable(updateTable + 1); 
                }}
            ></EditPersonModal>
            <DeletePersonModal
                show={ showDeletePersonModal }
                personId= { deletePersonId }
                onCancel={() => setShowDeletePersonModal(false)}
                onHide={() => setShowDeletePersonModal(false)}
                onDeleted={() => { 
                    setShowDeletePersonModal(false); 
                    setUpdateTable(updateTable + 1); 
                }}                    
            ></DeletePersonModal>
            <SMSSender
                show={showSMSSendModal}
                onHide={() => setShowSMSSendModal(false)}
                onCancel={() => setShowSMSSendModal(false)}
                customMessages={action == "confirmation"}
                recipients={selectedItems.map(i => {
                    return {
                        number: i.phone,
                        name: i.lastname + ", " + i.firstname,
                        message: action == "confirmation" ? generateConfirmationMessageSms(i) : undefined
                    }
                })}
            ></SMSSender>
            <EmailSender
                show={showEmailSendModal}
                onHide={() => setShowEmailSendModal(false)}
                onCancel={() => setShowEmailSendModal(false)}
                customMessages={action == "confirmation"}
                attachMapImage={action == "confirmation"}
                recipients={selectedItems.map(i => {
                    return {
                        email: i.email,
                        name: i.lastname + ", " + i.firstname,
                        subject: "",
                        message: action == "confirmation" ? generateConfirmationMessageEmail(i) : undefined
                    }
                })}
            ></EmailSender>
        </div>
    );
}

export default BookingGuests;